import { Injectable } from '@angular/core';

import { ApiService } from '@frontend/sports/common/api-utils';
import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { firstValueFrom } from 'rxjs';

import { AutoCashoutResponse, RemoveAutoCashoutRequest, SetAutoCashoutRequest } from '../../my-bets-base/models/early-payout';
import { EarlyPayoutConst, PayoutError } from '../../my-bets-base/models/early-payout-types';

@Injectable()
export class AutoCashoutService {
    private readonly logger: SportsRemoteLogger;

    constructor(
        private apiService: ApiService,
        loggerFactory: LoggerFactory,
    ) {
        this.logger = loggerFactory.getLogger('AutoCashoutService');
    }

    async setEarlyPayoutAmount(request: SetAutoCashoutRequest): Promise<AutoCashoutResponse> {
        try {
            return await firstValueFrom(this.apiService.post<AutoCashoutResponse>('autoCashout/set', request));
        } catch (error: any) {
            if (error.errorCode !== 'Unauthenticated') {
                this.logger.error(error, 'Request set auto cashout failed.');
            }

            return Promise.resolve(<AutoCashoutResponse>{
                betNumber: '',
                possible: false,
                setAutoCashoutErrors: [<PayoutError>{ type: EarlyPayoutConst.AcGenericError }],
            });
        }
    }

    async removeEarlyPayoutAmount(request: RemoveAutoCashoutRequest): Promise<AutoCashoutResponse> {
        try {
            return await firstValueFrom(this.apiService.post<AutoCashoutResponse>('autoCashout/remove', request));
        } catch (error: any) {
            if (error.errorCode !== 'Unauthenticated') {
                this.logger.error(error, 'Request remove auto cashout failed.');
            }

            return Promise.resolve(<AutoCashoutResponse>{
                betNumber: '',
                possible: false,
                setAutoCashoutErrors: [<PayoutError>{ type: EarlyPayoutConst.AcGenericError }],
            });
        }
    }
}
